import {GridRowModel} from '@mui/x-data-grid'
import {Recurrence} from '../../../domain/Recurrence'
import {Frequency, FrequencyCode} from '../../../domain/Frequency'
import {TransactionTypeCode} from '../../../domain/TransactionType'
import {v4 as uuidv4} from 'uuid'

export const mapRecurrencesToGridRows = (recurrences: Recurrence[]): GridRowModel[] =>
  recurrences.map(r => ({
    id: r.id,
    type: r.type,
    description: r.description,
    amount: r.amount,
    frequency: r.frequency,
    startMonth: r.startMonth,
    startYear: r.startYear,
    endMonth: r.endMonth,
    endYear: r.endYear,
    onMonth: r.onMonth,
  }))

export const mapGridRowsToRecurrences = (rows: GridRowModel[]): Recurrence[] =>
  rows.map(row => ({
    id: row.id,
    type: row.type,
    description: row.description,
    amount: row.amount,
    frequency: row.frequency,
    startMonth: row.startMonth,
    startYear: row.startYear,
    endMonth: row.endMonth,
    endYear: row.endYear,
    onMonth: row.onMonth,
  }))

export const handleRecurrenceCreate = (rows: GridRowModel[]): GridRowModel[] => ([
  ...rows,
  {id: uuidv4(), type: TransactionTypeCode.ADJUSTMENT, description: '<Nouvelle récurrence>', amount: 0, frequency: FrequencyCode.MONTH},
])

export const handleRecurrenceDelete = (id: string, rows: GridRowModel[]): GridRowModel[] =>
  rows.filter(row => row.id !== id)

// Ré-expression de l'ancien isCellEditable, indépendante de la DataGrid.
export const isFieldEditable = (frequency: Frequency, field: string): boolean => {
  if (frequency === FrequencyCode.MONTH && field === 'onMonth') return false
  if (frequency === FrequencyCode.YEAR && (field === 'startMonth' || field === 'endMonth')) return false
  return true
}
